export const API = {
  NB_CHANNELS: '/api/v1/fetchNBPaymentChannels',
  OPTIONS: '/api/v2/fetchPaymentOptions',
  BIN: '/api/v1/fetchBinDetail',
  SEND_OTP: '/api/v1/login/sendOtp',
  VAL_OTP: '/api/v2/login/validateOtp',
  PT: '/api/v1/processTransaction',
  BAL: '/api/v1/fetchBalanceInfo',
  EMI: '/api/v1/fetchEMIDetail',
  VPA: '/api/v1/fetchVpaDetails',
  PROMO: '/api/v1/fetchPromoCodeDetail',
  TRANS_STATUS: '/v1/transactionStatus',
  MERCHANT_CONFIG: '/theme',
  VALIDATE_VPA: '/api/v1/vpa/validate',
  LOG_OUT: '/api/v2/logout/user',
  CART: '/api/v1/cart',
  CARD_DETAILS: '/api/v1/fetchCardDetails',
  FETCH_EMI_BANK_DETAILS: '/api/',
  FETCH_PCF_DETAILS: '/api/v1/fetchPcfDetails',
  APPLY_PROMO: '/api/v1/applyPromo',
  FETCH_ALL_PAYMENT_OFFERS: '/api/v1/fetchAllPaymentOffers',
  VALIDATE_IFSC: '/service/getBank',
  GET_IFSC: '/service/getList',
  EMI_BANKS: '/api/v1/emiSubvention/banks',
  EMI_TENURE: '/api/v1/emiSubvention/tenures',
  EMI_VALIDATE: '/api/v1/emiSubvention/validateEmi',
  CACHE_CARD_TOKEN: '/PAYTM_EXPRESS/getCardToken/emi',
  VALIDATE_PRN: '/api/v1/validatePRN'
};

export const ERRORS = {
  CHECKOUT: 'API constructor mandatory fields => mid,orderId and token',
  UI: 'UI constructor mandatory fields => mid,orderId and txnToken',
  MOBILE: 'Mobile number cannot be null or empty',
  INVALID_MOBILE: 'Mobile number should be valid and of 10 digits',
  OTP: 'OTP cannot be null or empty',
  BIN: 'Card number cannot be blank or less than 6 digit',
  EMI: 'Channel code cannot be empty or number',
  BAL: 'Paymode should be non-empty and of string type',
  PAY: 'Pay object cannot be empty',
  MID: 'Merchant id should not be null',
  ORDERID: 'Order id should not be null',
  VPA: 'Enter a valid vpa',
  PCF: 'Pay methods should not be null'
};

export const PAYMODE = {
  WALLET: 'BALANCE',
  PAYMENT_BANK: 'PPBL',
  GIFT_VOUCHER: 'MGV',
  POSTPAID: 'PDC',
  CARD: 'CARD',
  EMI: 'EMI',
  NB: 'NB',
  UPI: 'UPI',
  COD: 'COD',
  LOGIN: 'LOGIN'
};

export const ELEMENT_PAYMODE = {
  PAY_WITH_PAYTM: 'PAY WITH PAYTM',
  CARD: 'CARD',
  EMI: 'EMI',
  NB: 'NB',
  UPI: 'UPI',
  SCAN_AND_PAY: 'SCAN AND PAY'
};

export const TOKEN = {
  SSO: 'SSO',
  TXN: 'TXN_TOKEN',
  ACCESS: 'ACCESS'
};

export const PAYMENT_FLOW = {
  ADDANDPAY: 'ADDANDPAY',
  NONE: 'NONE',
  HYBRID: 'HYBRID'
};

export const FLOW = {
  DEFAULT: 'DEFAULT',
  DEFERRED: 'DEFERRED'
};

export const EVENT = {
  API_INIT: 'API_INIT',
  API_STATUS: 'API_STATUS'
};

export const METHOD = {
  GET: 'GET',
  POST: 'POST'
};

export const MESSAGE = {
  GENERIC_ERROR: 'Something went wrong'
};

export const LOGGER = {
  DEBUG: 'DEBUG',
  INFO: 'INFO'
};
export const EMI_SUBVENTION_STRATEGY = {
  ITEM_BASED: 'ITEM_BASED',
  AMOUNT_BASED: 'AMOUNT_BASED'
};
export const CONTENT_TYPE = {
  JSON: 'application/json',
  FORM_URLENCODED: 'application/x-www-form-urlencoded'
};

export const EMI_SUBVENTION_ITEM_KEYS = {
  BRAND_ID: 'brandId',
  CATEGORY_LIST: 'categoryList',
  MODEL: 'model',
  EAN: 'ean'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/constant.js